import lodash from 'lodash';

const state = () => ({
  examinations: [],
  vaccinations: [],
  reports: [],
  reportsLoading: false,
  appointments: [],
  appointmentsLoading: false,
  entryNotes: '',
  editEntryFormData: {},
  editEntryMedicalProcedureData: {},
  medicalProcedureDetailFrom: null
});

const getters = {
  examinations(state) {
    return state.examinations;
  },
  vaccinations(state) {
    return state.vaccinations;
  },
  reports(state) {
    return state.reports;
  },
  reportsLoading(state) {
    return state.reportsLoading;
  },
  appointments(state) {
    return state.appointments;
  },
  appointmentsLoading(state) {
    return state.appointmentsLoading;
  },
  entryNotes(state) {
    return state.entryNotes;
  },
  editEntryFormData(state) {
    return state.editEntryFormData;
  },
  editEntryMedicalProcedureData(state) {
    return state.editEntryMedicalProcedureData;
  },
  medicalProcedureDetailFrom(state) {
    return state.medicalProcedureDetailFrom;
  }
};

const mutations = {
  resetStore(state) {
    state.examinations = [];
    state.vaccinations = [];
    state.reports = [];
    state.entryNotes = '';
    state.editEntryFormData = {};
    state.editEntryMedicalProcedureData = {};
  },
  setExaminations(state, payload) {
    state.examinations = payload;
  },
  setVaccinations(state, payload) {
    state.vaccinations = payload;
  },
  setReports(state, payload) {
    state.reports = payload;
  },
  setReportsLoading(state, payload) {
    state.reportsLoading = payload;
  },
  setAppointments(state, payload) {
    state.appointments = payload;
  },
  setAppointmentsLoading(state, payload) {
    state.appointmentsLoading = payload;
  },
  updateEntryNotes(state, payload) {
    state.entryNotes = payload;
  },
  setEditEntryFormData(state, payload) {
    state.editEntryFormData = payload;
  },
  setEditEntryMedicalProcedureData(state, payload) {
    state.editEntryMedicalProcedureData = payload;
  },
  updateMedicalProcedureDetailFrom(state, payload) {
    state.medicalProcedureDetailFrom = payload;
  }
};

const actions = {
  setExaminations({ commit }, payload) {
    commit('setExaminations', payload);
  },
  setVaccinations({ commit }, payload) {
    commit('setVaccinations', payload);
  },
  setReports({ commit }, payload) {
    commit('setReports', payload);
  },
  setAppointments({ commit }, payload) {
    commit('setAppointments', payload);
  },
  updateStaticReportData({ commit, state }, payload) {
    const medicalProcedures = lodash.cloneDeep(
      payload.medicalProcedureData.type === 'examination' ? state.examinations : state.vaccinations
    );
    const medicalProcedureIndex = medicalProcedures.findIndex(
      val => val.id === payload.medicalProcedureData.id
    );

    if (medicalProcedureIndex !== -1) {
      medicalProcedures[medicalProcedureIndex].lastReport = payload.date;
      medicalProcedures[medicalProcedureIndex].scheduledReport = payload.scheduledReport;
      medicalProcedures[medicalProcedureIndex].scheduledMissed = !payload.scheduledReport
        ? false
        : payload.scheduledReport && new Date(payload.scheduledReport) < new Date();

      if (payload.medicalProcedureData.type === 'examination') {
        commit('setExaminations', medicalProcedures);
      } else {
        commit('setVaccinations', medicalProcedures);
      }
    }
  },
  setEditEntryMedicalProcedureData({ commit }, payload) {
    commit('setEditEntryMedicalProcedureData', payload);
  }
};

export const prevention = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
